import React from 'react';
import CatalogPage from '../../components/CatalogPage/CatalogPage';
import { lampadaService } from '../../services/api';

const LampadaRegistration: React.FC = () => (
  <CatalogPage
    title="Lâmpadas"
    subtitle="Cadastre e gerencie os modelos de lâmpadas disponíveis no checklist de conclusão."
    listTitle="Lâmpadas cadastradas"
    listDescription="Estes modelos aparecerão no campo Lâmpada encontrada/instalada do checklist mobile."
    placeholder="Nome da lâmpada (ex: 150W VS)"
    service={lampadaService}
  />
);

export default LampadaRegistration;
